<script>
import { mapGetters } from 'vuex'
import AppBus from '@C/bus/app-bus.vue'
import Deferred from '@/js/deferred.js'
import { needsExtensionUpdate } from '@/js/utils.js'

export default {
  computed: {
    ...mapGetters([
      'hasExtension',
      'extensionVersion',
      'isChrome',
      'isFirefox',
      'isEdge',
      'isOpera',
      'isMobile',
      'chromeExtensionURL',
      'edgeExtensionURL',
      'operaExtensionURL',
      'firefoxExtensionURL'
    ]),
    browserSupportsExtension () {
      return this.isChrome || this.isFirefox || this.isOpera || this.isEdge
    },
    browserExtensionPage () {
      if (this.isEdge) {
        return 'edge://extensions'
      } else if (this.isChrome || this.isOpera) {
        return `chrome://extensions`
      } else if (this.isFirefox) {
        return `about:addons`
      } else {
        throw new Error('No extension page for unsupported browser')
      }
    },
    browserExtensionURL () {
      if (this.isEdge) {
        return this.edgeExtensionURL
      } else if (this.isOpera) {
        return this.operaExtensionURL
      } else if (this.isChrome) {
        return this.chromeExtensionURL
      } else if (this.isFirefox) {
        return this.firefoxExtensionURL
      } else {
        throw new Error(`No extension URL defined for unsupported browser`)
      }
    }
  },
  data () {
    return {
      hasValidExtensionVersion: false,
      extensionHelperReady: new Deferred()
    }
  },
  watch: {
    extensionVersion () {
      this.updateExtensionVersionValidity()
    }
  },
  methods: {
    loadExtensionHelperVideo (id) {
      let type, videoURL, videoSelector
      switch (id) {
        case 'web':
          type = 'url'
          videoURL = 'https://blog.twoseven.xyz/extension@v2.0.0/extension@v2.0.0-arbitrary-videos.mp4'
          videoSelector = 'web'
          break
      }
      const result = {
        type,
        videoSelector,
        videoURL,
        videoData: {}
      }
      AppBus.$emit(`load-${videoSelector}-video`, result)
    },
    needsExtensionUpdate,
    updateExtensionVersionValidity () {
      this.hasValidExtensionVersion = !needsExtensionUpdate(this.minExtensionVersion || '0.0.0', this.extensionVersion)
    }
  },
  async beforeMount () {
    this.updateExtensionVersionValidity()
    this.extensionHelperReady.resolve()
  }
}
</script>
